import type { FC } from 'react';
import { DPX_URL } from '@Shared/env/env';
import '@Styles/auth-required.css';

export const AuthError: FC = () => {
  return (
    <div className="auth-error__wrapper">
      <div className="auth-error__card">
        <div className="auth-error__icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="auth-error__icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.8}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            />
          </svg>
        </div>
        <div>
          <p className="auth-error__title">Error de autenticación</p>
          <p className="auth-error__description">
            No se ha podido verificar tu sesión. Por favor, vuelve a iniciar sesión en la DPX.
          </p>
        </div>
        <a href={DPX_URL} className="auth-error__cta">
          Ir a la DPX
        </a>
      </div>
    </div>
  );
};
